var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardTopBlockBgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 84,
    viewBox: "0 0 145 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 23.8605,
    height: 18.0421,
    rx: 1.5,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 69.0393 0.822266)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4025 20.599C56.2048 20.4394 53.7414 19.7627 53.4699 18.3329M55.7773 23.1642C53.9193 22.8894 49.9661 21.7257 49.018 19.2694M54.5589 25.5659C52.084 25.1744 46.7142 23.5287 45.0344 20.0777M52.826 27.9099C49.8111 27.4991 43.2184 25.5572 40.9665 21.0762",
    stroke: "white",
    strokeWidth: 1.37985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 4.47035e-8,
    y: -0.25,
    width: 19.2897,
    height: 19.2897,
    rx: 9.64486,
    transform: "matrix(-0.866025 -0.5 0.866026 -0.5 76.562 83.496)",
    stroke: "url(#paint0_linear_2_1207)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 4.47035e-8,
    y: -0.25,
    width: 19.2897,
    height: 19.2897,
    rx: 9.64486,
    transform: "matrix(-0.866025 -0.5 0.866026 -0.5 66.2158 77.5223)",
    stroke: "url(#paint1_linear_2_1207)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1207",
    x1: 9.89486,
    y1: 0,
    x2: 9.89486,
    y2: 19.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1207",
    x1: 9.89486,
    y1: 0,
    x2: 9.89486,
    y2: 19.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTopBlockBgEmpty);
export default __webpack_public_path__ + "static/media/card-top-block-bg-empty.18e969219b2ec7273dc257317019c898.svg";
export { ForwardRef as ReactComponent };